import { memo } from 'react';

import { ChartProvider } from '@/features/_shared/chart/context/ChartContext';
import type { FileChartWidgetData } from '@/features/_shared/widget-registry';
import CustomChart from '@/features/markets/components/CustomChart';
import { PageInformationContext } from '@/shared/lib/PageInformationContext';

export const FileChartWidget = memo(({ data }: { data: FileChartWidgetData }) => {
  const metadata: Record<string, object | string> = {
    graphType: 'custom',
    seriesFileName: data.seriesFileName,
    configFileName: data.configFileName,

    ...(data.queryFileId === undefined ? {} : { queryFileId: data.queryFileId }),
    ...(data.downloadFileId === undefined ? {} : { downloadFileId: data.downloadFileId }),
    ...(data.timeRangeButtons === undefined ? {} : { timeRangeButtons: data.timeRangeButtons })
  };

  return (
    <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
      <ChartProvider>
        <CustomChart metadata={metadata} />
      </ChartProvider>
    </PageInformationContext>
  );
});

FileChartWidget.displayName = 'FileChartWidget';
